import { http } from './http';

// Warehouses
export async function getWarehouses(params) {
    return http.get('wms/warehouses/', { params });
}

export async function createWarehouse(data) {
    return http.post('wms/warehouses/', data);
}

export async function updateWarehouse(id, data) {
    return http.patch(`wms/warehouses/${id}/`, data);
}

export async function deleteWarehouse(id) {
    return http.delete(`wms/warehouses/${id}/`);
}

// Warehouse Zones
export async function getWarehouseZones(params) {
    return http.get('wms/warehouse-zones/', { params });
}

export async function createWarehouseZone(data) {
    return http.post('wms/warehouse-zones/', data);
}

export async function deleteWarehouseZone(id) {
    return http.delete(`wms/warehouse-zones/${id}/`);
}

// Rows
export async function getRows(params) {
    return http.get('wms/rows/', { params });
}

export async function createRow(data) {
    return http.post('wms/rows/', data);
}

export async function deleteRow(id) {
    return http.delete(`wms/rows/${id}/`);
}

// Racks
export async function getRacks(params) {
    return http.get('wms/racks/', { params });
}

export async function createRack(data) {
    return http.post('wms/racks/', data);
}

export async function deleteRack(id) {
    return http.delete(`wms/racks/${id}/`);
}

// Levels
export async function getLevels(params) {
    return http.get('wms/levels/', { params });
}

export async function createLevel(data) {
    return http.post('wms/levels/', data);
}

export async function deleteLevel(id) {
    return http.delete(`wms/levels/${id}/`);
}
